import { di } from 'react-magnetic-di';

import { type Menu } from '@atlassian/conversation-assistant-store/controllers/ui-store';
import { useConversationActionsStore } from '@atlassian/rovo-conversation-actions/conversation-actions-store';

import { type ScreenType } from '../use-calculated-screen-type';

import type { ScreenState } from './ScreenState';

/**
 * Hook to track the current view state, which encapsulates menu, action, and chat views
 */
export const useScreenState = (screenType: ScreenType, activeMenu: Menu): ScreenState => {
	di(useConversationActionsStore);
	const [{ activeAction }] = useConversationActionsStore();

	if (activeMenu !== 'none') {
		return {
			currentViewType: 'menu' as const,
			currentViewSubtype: activeMenu,
		};
	}

	if (activeAction) {
		return {
			currentViewType: 'action' as const,
			action: { id: activeAction.id }, // just grabbing ID for now
		};
	}

	// If it's not an activeAction or activeMenu, it's guaranteed to be one of the screenType cases
	return {
		currentViewType: 'chat' as const,
		currentViewSubtype: screenType,
	};
};
